import React from 'react';

export const RadioGroupPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { label, options, name } = specificAttrs || {};
  const optionsArray = (options || 'Option A,Option B').split(',');
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div>
      {label && <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>{label}</label>}
      {optionsArray.map((option, idx) => (
        <div key={idx} style={{ marginBottom: '6px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input type="radio" name={name || 'radio_group'} />
            <span style={{ fontSize: '14px' }}>{option.trim()}</span>
          </label>
        </div>
      ))}
      </div>
    </div>
  );
};
